// extracted by mini-css-extract-plugin
export default {"root":"AdminBillingContent_root__--cyo"};